/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useCallback } from "react";
import { Card, Table, DatePicker, Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { formatIndianNumber, formatIndianCurrency } from "../../../../utils";
import "./style.scss";
import "../style.scss";

const { Title } = Typography;

const CPWiseView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedDate, setSelectedDate] = useState(moment());
    const [loading, setLoading] = useState(false);
    const [cpWiseData, setCpWiseData] = useState([]);
    const [zone, setZone] = useState("");
    const [hub, setHub] = useState("");
    const [reportType, setReportType] = useState("Piece Rate");
    const [reportCategory, setReportCategory] = useState("Business Data");
    const [dataType, setDataType] = useState("today"); // "today" or "range"

    useEffect(() => {
        // Get zone, hub, report category, type, and data type from location state if available
        const zoneValue = location.state?.zone || "";
        const hubValue = location.state?.hub || "";
        const category = location.state?.reportCategory || "Business Data";
        const type = location.state?.reportType || "Piece Rate";
        const typeMode = location.state?.type || "today";
        
        setZone(zoneValue);
        setHub(hubValue);
        setReportCategory(category);
        setReportType(type);
        setDataType(typeMode);
        
        if (location.state?.date) {
            // Convert string date back to moment object
            const dateValue = typeof location.state.date === "string" 
                ? moment(location.state.date) 
                : moment(location.state.date);
            setSelectedDate(dateValue);
        }
    }, [location.state]);

    const loadCPWiseData = useCallback(() => {
        if (!hub || !zone) return;
        
        setLoading(true);
        
        // TODO: Replace with actual API call based on reportCategory, zone, hub, and dataType
        // API call should be made here with reportCategory, zone, hub, dataType, and selectedDate
        
        // For now, set empty data
        setCpWiseData([]);
        setLoading(false);
    }, [reportCategory, hub, zone, dataType]);

    useEffect(() => {
        // Load data when component mounts or reportCategory/hub/zone/dataType changes
        loadCPWiseData();
    }, [loadCPWiseData]);

    const handleDateSubmit = () => {
        loadCPWiseData();
    };

    const todayDate = selectedDate.format("DD/MM/YYYY");
    const rangeStartDate = selectedDate.startOf("month").format("DD/MM/YYYY");
    const rangeEndDate = selectedDate.format("DD/MM/YYYY");
    const dateRange = `${rangeStartDate} - ${rangeEndDate}`;
    const displayDate = dataType === "today" ? todayDate : dateRange;

    const handleGoBack = () => {
        const routeMap = {
            "Business Data": "/hub-wise-business-data",
            "Shipment Counts": "/hub-wise-shipment-counts",
            "Delivery Data": "/hub-wise-delivery-data",
        };
        navigate(routeMap[reportCategory] || "/hub-wise-business-data", {
            state: {
                zone: zone,
                date: selectedDate.format("YYYY-MM-DD"),
                reportType: reportType,
                reportCategory: reportCategory,
                type: dataType,
            },
        });
    };

    // CP-wise table columns
    const cpWiseColumns = [
        {
            title: "CP",
            dataIndex: "cp",
            key: "cp",
            width: "50%",
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            width: "50%",
            align: "right",
        },
    ];

    return (
        <div className="director-dashboard cp-wise-page">
            {/* Breadcrumb */}
            <div className="cp-wise-breadcrumb">
                <Button
                    type="text"
                    icon={<ArrowLeftOutlined />}
                    onClick={handleGoBack}
                    className="back-button"
                >
                    HUB Wise {reportCategory}
                </Button>
                <span className="breadcrumb-separator">/</span>
                <span className="breadcrumb-current">Business Statistics Report</span>
            </div>

            {/* Date Filter */}
            <Card className="cp-wise-filter-card">
                <div className="cp-wise-date-filter">
                    <label className="cp-wise-date-label">Date:</label>
                    <DatePicker
                        format="DD/MM/YYYY"
                        value={selectedDate}
                        onChange={(date) => setSelectedDate(date || moment())}
                        className="cp-wise-date-picker"
                    />
                    <Button type="primary" onClick={handleDateSubmit} className="cp-wise-submit-btn">
                        Submit
                    </Button>
                </div>
            </Card>

            {/* CP Wise Table */}
            <Card className="cp-wise-table-card">
                <Title level={4} className="cp-wise-table-title">
                    CP Wise {reportCategory} - {displayDate} - {zone} - {hub} {reportCategory === "Business Data" ? `(${reportType})` : ""}
                </Title>
                <Table
                    columns={cpWiseColumns}
                    dataSource={cpWiseData}
                    pagination={false}
                    loading={loading}
                    size="small"
                    className="cp-wise-table"
                    rowClassName={(record, index) => {
                        if (record.cp === "Total") {
                            return "cp-wise-total-row";
                        }
                        return index % 2 === 0 ? "cp-wise-row-even" : "cp-wise-row-odd";
                    }}
                />
            </Card>
        </div>
    );
};

export default CPWiseView;

